import { ChangeDetectionStrategy, Component, OnInit, inject, input, signal } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';

import SurveyAnswer from 'entity/SurveyAnswer';
import SurveyQuestion from 'entity/SurveyQuestion';

import { AnswerService } from '../../services/answer.service';

@Component({
  selector: 'selector-survey',
  templateUrl: './selector-survey.component.html',
  styleUrls: ['./selector-survey.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectorSurveyComponent implements OnInit {
  private _answerService = inject(AnswerService);

  public readonly question = input<SurveyQuestion>();
  private readonly answer = signal<SurveyAnswer | undefined>(undefined);

  public ngOnInit(): void {
    const newAnswer = {
      surveyQuestionId: this.question()?.surveyQuestionId,
      skipped: true,
    };
    this.answer.set(newAnswer);
    this._answerService.trackAnswer(newAnswer);
  }

  public valueSelected(e: MatRadioChange): void {
    const val = e.value;
    const currentAnswer = this.answer();
    if (currentAnswer) {
      const newAnswer = { ...currentAnswer, answer: String(val), skipped: false };
      this.answer.set(newAnswer);
      this._answerService.trackAnswer(newAnswer);
    }
  }
}
